import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { securityResolver, SentryGuard, sakerCanActivateGuard } from 'saker-core';
import { DashboardComponent } from './Component/dashboard/dashboard.component';
import { ProjectScenariosComponent } from './Component/ProjectScenario/project-scenarios/project-scenarios.component';
import { ProjectScenarioComponent } from './Component/ProjectScenario/project-scenario/project-scenario.component';
import { ProjectScenarioImportComponent } from './Component/ProjectScenario/project-scenario-import/project-scenario-import.component';
import { NoteComponent } from './Component/ProjectScenario/note/note.component';

const appRoutes: Routes = [

	{
		path: 'home',
		component: DashboardComponent,
		resolve: { data: securityResolver },
		data: { permission: ['dashboard-show-page'] },
		canDeactivate: [SentryGuard],
		canActivate: [sakerCanActivateGuard]
	},

	{
		path: 'projectScenarios/:mnemonic',
		component: ProjectScenariosComponent,
		resolve: { data: securityResolver },
		data: { permission: ['show-project-scenarios'] },
		canDeactivate: [SentryGuard],
		canActivate: [sakerCanActivateGuard]
	},

	{
		path: 'projectScenario/:id',
		component: ProjectScenarioComponent,
		resolve: { data: securityResolver },
		data: { permission: ['show-project-scenarios'] },
		canDeactivate: [SentryGuard],
		canActivate: [sakerCanActivateGuard]
	},

	{
		path: 'projectScenarioImport/:mnemonic',
		component: ProjectScenarioImportComponent,
		resolve: { data: securityResolver },
		data: { permission: ['show-project-scenarios'] },
		canDeactivate: [SentryGuard],
		canActivate: [sakerCanActivateGuard]
	},
	
	{
		path: 'note/:projectScenarioId/:noteId',
		component: NoteComponent,
		resolve: { data: securityResolver },
		data: { permission: ['show-notes'] },
		canDeactivate: [SentryGuard],
		canActivate: [sakerCanActivateGuard]
	},
];

@NgModule({
	imports: [RouterModule.forRoot(appRoutes, { enableTracing: false, initialNavigation: 'enabledBlocking' })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
